module.exports = __webpack_public_path__ + "static/media/LandscapeCover.2b58331e.jpg";